import {config} from 'config/env';
import {AddressTypeEnum, CreateAddressInputType, UpdateAddressInputType, UserAddressV2} from 'types';
import {fetchRequest} from 'utils';

export async function getUserAddressesV2(idToken?: string, addressType?: AddressTypeEnum): Promise<UserAddressV2[]> {
  const result = await fetchRequest<UserAddressV2[]>(
    'GET',
    `${config.LOCATION_API_BASE_URL}/location/api/v1/addresses`,
    {
      idToken,
      searchParams: {
        addressType: addressType
      }
    }
  );
  return result;
}

export async function createUserAddressV2(
  idToken: string,
  createAddressInput: CreateAddressInputType
): Promise<UserAddressV2> {
  const result = await fetchRequest<UserAddressV2>(
    'POST',
    `${config.LOCATION_API_BASE_URL}/location/api/v1/addresses`,
    {
      json: createAddressInput,
      idToken
    }
  );
  return result;
}

export async function updateUserAddressV2(
  idToken: string,
  addressId: string,
  updateAddressInput: UpdateAddressInputType
): Promise<UserAddressV2> {
  const result = await fetchRequest<UserAddressV2>(
    'PUT',
    `${config.LOCATION_API_BASE_URL}/location/api/v1/addresses/${addressId}`,
    {
      json: updateAddressInput,
      idToken
    }
  );
  return result;
}
